import { DateTime } from "luxon";
import { BID_TYPE } from "./bidConstants";
import { getThanksGivingDateOfTheYear } from "../dateHelper";
import { SELECT_IAM_FTO_BID_EFFECTIVE_MONTH_LIST } from "../constants";

export const getFirstDayOfCurrentMonth = (schedMonth, schedYear) => {
  const formattedDate = DateTime.fromFormat(`${schedMonth} ${schedYear}`, "MMMM yyyy");
  return formattedDate.startOf("month");
};

export const getLastDayOfCurrentMonth = (schedMonth, schedYear) => {
  const formattedDate = DateTime.fromFormat(`${schedMonth} ${schedYear}`, "MMMM yyyy");
  return formattedDate.endOf("month");
};

export const getFirstDayWithMonthOffset = (schedMonth, schedYear, monthsToSubtract) => {
  const formattedDate = DateTime.fromFormat(`${schedMonth} ${schedYear}`, "MMMM yyyy");
  const offsetMonthStart = formattedDate.minus({ months: monthsToSubtract });
  return offsetMonthStart.startOf("month");
};

export const getLastDayWithMonthOffset = (schedMonth, schedYear, monthsToSubtract) => {
  const formattedDate = DateTime.fromFormat(`${schedMonth} ${schedYear}`, "MMMM yyyy");
  const offsetMonthStart = formattedDate.minus({ months: monthsToSubtract });
  return offsetMonthStart.endOf("month");
};

export const calcDailyAllotmentInitialState = {
  amOrPmCount: 0,
};

export const getTotalAllotments = (dayState) => dayState.reduce((total, day) => total + day.amOrPmCount, 0);

export const getTotalEmployeesCount = (bidGroup = []) => bidGroup?.filter((employee) => !employee.isRemoved).length;

export const getBidName = (bidChoiceData) => {
  return bidChoiceData
    ? `${bidChoiceData?.station} | ${bidChoiceData?.workgroup} | ${
        bidChoiceData.schedYear
      } ${bidChoiceData.schedMonth.substr(0, 3)}`
    : "";
};

export const getNonEmptyChoices = (choices) => {
  if (
    choices !== undefined &&
    (choices[choices.length - 1] === "" ||
      (typeof choices[choices.length - 1] === "object" &&
        choices[choices.length - 1]?.date === "" &&
        choices[choices.length - 1]?.timeOffType === ""))
  ) {
    return choices.slice(0, -1);
  }

  return choices;
};

export const generateMTOBidChoiceRows = (choices, isReadOnly) => {
  if (isReadOnly) {
    return getNonEmptyChoices(choices).map((date, index) => ({
      id: index + 1,
      date: date,
    }));
  }
  return choices.map((date, index) => ({
    id: index + 1,
    date: date,
  }));
};

export const getDisabledDatesBasedOnSchedule = ({ scheduledMap, station, bidType, schedMonth, schedYear }) => {
  let disabledDates = [];

  for (const date in scheduledMap) {
    const schedule = scheduledMap[date];

    const isWorkingDayAtStation =
      schedule && schedule?.station === station && !schedule?.isNS && !schedule?.isOff && schedule?.shifts.length > 0;

    // if it is not working day, then disable it on monthly timeoff bids.
    if (!isWorkingDayAtStation) {
      disabledDates.push(date);
    }
  }

  if (
    bidType === BID_TYPE.FTO ||
    bidType === BID_TYPE.TWU_DAT_FTO ||
    bidType === BID_TYPE.IAM_DAT ||
    bidType === BID_TYPE.NC_PTO_FTO ||
    bidType === BID_TYPE.NC_PTO_GOC_HOL
  ) {
    const convertedSchedMonth = SELECT_IAM_FTO_BID_EFFECTIVE_MONTH_LIST.indexOf(schedMonth) + 1;
    if (convertedSchedMonth === 11) {
      const thanksgivingDate = getThanksGivingDateOfTheYear(parseInt(schedYear));
      disabledDates.push(thanksgivingDate.toFormat("yyyy-MM-dd"));
    } else if (convertedSchedMonth === 12) {
      disabledDates.push(`${schedYear}-12-25`);
    }
  }
  return disabledDates;
};

export const isHoliday = (date, schedYear, thanksgivingDate) => {
  return (
    (date.month === 11 && date.day === thanksgivingDate.day && date.year === thanksgivingDate.year) || // Thanksgiving
    (date.month === 12 && date.day === 25 && date.year === schedYear) // Christmas
  );
};
